import ContentCategory from './contentCategory';

const FOLDER                = 1;
const PAGE                  = 2;
const HTML                  = 3;
const LINK                  = 4;
const FILE                  = 5;
const LTI                   = 6;
const LINK_GROUP            = 7;
const TASK                  = 8;
const FORUM                 = 9;
const QUIZ                  = 15;
const WEBCONFERENCE         = 19;
const EMBEDDED_LINK         = 23;
const AVALIA                = 27;
const H5P                   = 28;
const SCORM                 = 31;


const logMiddlewareError = (message, context, action, ...props) => {
  console.error(`[TopicType Error] ${message}`, {
    context,
    action: action || 'Ensure that the \'topicTypes\' middleware is being called in the page root',
    ...props
  });
};

const getPermissionAliasById = (typeId, action) => {
  const specialTypePermissions = {
    [FOLDER] : `resources_folder_${action}`,
    [PAGE]   : `resources_page_${action}`
  };

  if (specialTypePermissions[typeId]) {
    return specialTypePermissions[typeId];
  }

  const getterTopicTypes = window.$nuxt.$store.getters['plataforma/institutionConfiguration/getterTopicTypes'];

  if (!getterTopicTypes || !Object.keys(getterTopicTypes).length) {
    logMiddlewareError('Topic types not loaded, returning null', 'getPermissionAliasById');
    return null;
  }

  const type = getterTopicTypes[typeId];

  if (!type) {
    logMiddlewareError('Topic type not found, returning null', 'getPermissionAliasById', null, {
      availableTypes : getterTopicTypes,
      requestedType  : typeId
    });
    return null;
  }

  return ContentCategory.getCategoryPermissionAlias(type.category_type_id, action);
};

const getPermissions = (action, { includeMarketplace } = { includeMarketplace: true }) => {
  const permissions = [
    `resources_html_${action}`,
    `resources_forum_${action}`,
    `resources_lti_${action}`,
    `resources_link_group_${action}`,
    `resources_task_${action}`,
    `resources_avalia_activity_${action}`,
    `resources_quiz_${action}`,
    `resources_webconference_${action}`,
    `resources_embedded_link_${action}`,
    `resources_h5p_${action}`,
    `resources_scorm_${action}`
  ];
  if (includeMarketplace) {
    permissions.push(`marketplace_${action}`);
  }
  return permissions;
};

const isActivityContent = (typeId) => {
  const getterTopicTypes = window.$nuxt.$store.getters['plataforma/institutionConfiguration/getterTopicTypes'];

  if (!getterTopicTypes || !Object.keys(getterTopicTypes).length) {
    logMiddlewareError('Topic types not loaded, returning false', 'isActivityContent');
    return false;
  }

  const type = getterTopicTypes[typeId];

  if (!type) {
    logMiddlewareError('Topic type not found, returning false', 'isActivityContent', null, {
      availableTypes : getterTopicTypes,
      requestedType  : typeId
    });
    return false;
  }

  return ContentCategory.activityCategories.includes(type.category_type_id);
};

const isInsidePage = (parentTopicId, parentTopicTypeId) => {
  return parentTopicId && parentTopicTypeId === PAGE;
};

const getInternationalizationTopicTypeKeyNameById = (topicTypeId) => {
  const getterTopicTypesNames = window.$nuxt.$store.getters['plataforma/institutionConfiguration/getterTopicTypesNames'];

  if (!getterTopicTypesNames || !Object.keys(getterTopicTypesNames).length) {
    logMiddlewareError('Topic types names not loaded, returning default name', 'getInternationalizationTopicTypeKeyNameById');
    return 'topicTypes.default';
  }

  if (!getterTopicTypesNames[topicTypeId]) {
    logMiddlewareError('Topic type name not found, returning default name', 'getInternationalizationTopicTypeKeyNameById', null, {
      availableTypes : getterTopicTypesNames,
      requestedType  : topicTypeId
    });
    return 'topicTypes.default';
  }

  return getterTopicTypesNames[topicTypeId];
};

export default {
  FOLDER,
  PAGE,
  HTML,
  LINK,
  FILE,
  LTI,
  LINK_GROUP,
  TASK,
  FORUM,
  QUIZ,
  WEBCONFERENCE,
  EMBEDDED_LINK,
  AVALIA,
  H5P,
  SCORM,
  logMiddlewareError,
  getPermissionAliasById,
  getPermissions,
  isActivityContent,
  isInsidePage,
  getInternationalizationTopicTypeKeyNameById
};
